export default __webpack_public_path__ + "static/media/error-alert.e463d156.mp3";